import LogRocket from 'logrocket';
import { IS_PROD } from '../constants/defaultValues';

if (IS_PROD) {
    LogRocket.init('c3vvsu/ozbet');
}

export const identifyLogRocketUser = (accountNumber, customVariables) => {
    if (IS_PROD) {
        LogRocket.identify(accountNumber, {
            // Add your own custom user variables here, ie:
            ...customVariables,
        });
    }
};

// export const logRocketReduxMiddleware = [];

// if (isProdEnvironment) {
//     logRocketReduxMiddleware.push(LogRocket.reduxMiddleware());
// }
